import { formatUrl } from '../utils/api';
import api from './api';
import { getStorage, hasStorage } from '../utils/storage';

export default async function CheckAuth() {
  var retorno = false;
  const token = getStorage('token');
  const tipo = getStorage('tipo');

  if (token === null) {
    retorno = false;
  } else {
    //valida token
    const url = formatUrl(process.env.REACT_APP_CHECK_TOKEN, token, tipo);
    await api
      .get(url)
      .then((response) => {
        if (response.data.status !== undefined) {
          if (response.data.status === 'success') {
            retorno = true;
          } else {
            retorno = false;
          }
        } else {
          retorno = false;
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  return retorno;
}

export const getUserType = (tipoNumber = null) => {
  const tipo = getStorage('tipo') ?? tipoNumber;
  if ((tipo === '1' || tipo === 1) && !hasStorage('isMemnon')) {
    return 'admin';
  } else if ((tipo === '2' || tipo === 2) && !hasStorage('isMemnon')) {
    return 'pesquisador';
  } else if ((tipo === '1' || tipo === 1) && hasStorage('isMemnon')) {
    return 'institucional';
  }
};
